<template>
    <router-link v-if="link && link.indexOf('://') >= 0 && link.indexOf('http') >= 0" class="button" :class="buttonClasses" :href="link" to="" :target="target">
        <slot></slot>
        <Icon v-if="icon" :name="icon"></Icon>
    </router-link>
    <router-link  v-else-if="link" class="button" :class="buttonClasses" :to="link" :target="target">
        <slot></slot>
        <Icon v-if="icon" :name="icon"></Icon>
    </router-link>
    <router-link  v-else-if="linkObject" class="button" :class="buttonClasses" :to="linkObject" :target="target">
        <slot></slot>
        <Icon v-if="icon" :name="icon"></Icon>
    </router-link>
    <button v-else-if="type === 'submit'" type="submitt" class="button" :class="buttonClasses" @click="emitClick">
        <slot></slot>
        <Loader class="button__preloader"  v-if="loading" color="white" size="small"></Loader>
        <Icon v-if="icon" :name="icon"></Icon>
    </button>
    <a v-else-if="externalLink" class="button" :href="externalLink" target="target">
        <slot></slot>
        <Icon v-if="icon" :name="icon"></Icon>
    </a>
    <div v-else class="button" :class="buttonClasses" @click="emitClick">
        <slot></slot>
        <Loader class="button__preloader" v-if="loading" color="white" size="small"></Loader>
        <Icon v-if="icon" :name="icon"></Icon>
    </div>
</template>

<script>

export default {
    name: "PumaButton",
    data() {
        return {
            workouts: [],
        }
    },
    props: {
        link: String,
        externalLink: String,
        target: String,
        type: String,
        linkObject: Object,
        loading: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: [String, Boolean],
            default: false,
        }
    },
    computed: {
        buttonClasses() {
            return `button--${this.type} ${this.small ? 'button--small' : ''} ${this.icon ? 'button--icon' : ''}`
        }
    },
    methods: {
        create_time() {
        },
        emitClick() {
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" soped>
.button {
    background: black;
    line-height: 42px;
    padding: 0 25px 2px;
    color: white;
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 4px;
    border: 1px solid black;
    transition: all .20s ease;
    cursor: pointer;
    position: relative;

    @include mq(tablet){
        padding: 0 40px 2px;
    }

    .no-touch &:hover {
        background: white;
        color: black;
        .loader {
            &__inner {
                span {
                    &:after {
                        border-color: $puma-color-black;
                    }
                }
            }
        }
    }

    &--light {
        border-color: white;
        background: white;
        color: black;

        .no-touch &:hover {
            background: rgba(white, 0.15);
            color: white;
        }
    }

    &--grey {
        background: $puma-color-neutral-90;
    }

    &--icon {
       display: inline-flex;
       align-items: center;
       padding: 0 20px 0 24px;
       text-transform: none;
    }

    &--small {
        font-size: $puma-size-font-sm;
        padding: 10px 22px 12px;
        line-height: normal;
    }

    &--border {
        border: 1px solid $puma-color-black;
    }

    &--outline {
        background: transparent;
        color: $puma-color-black;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

     &--red {
        background: $puma-color-brand-60;
        border: 1px solid $puma-color-brand-60;
        color: $puma-color-white;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &[disabled] {
        opacity: 0.5;
        pointer-events: none;
    }

    &__preloader {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        color: white;
    }

    .icon {
        margin-left: 8px;
    }
}
</style>